import { Component, OnInit } from '@angular/core';
import { Sprema } from './sprema';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-sprema',
  templateUrl: './sprema.component.html'
})
export class SpremaComponent extends BaseModalContainer<Sprema> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Sprema>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
